module.exports = __webpack_public_path__ + "img/icon-80.8081884e.png";